import axios from "axios";
import { BN_APP } from "../../../constants/constant";
import { getAccessToken } from "../../../utils/okta-config";

export const approveAccountingTransaction = async (billingDataIds) => {debugger;
  try {
    const response = await axios.post(
      `${BN_APP}/accounting-transaction/approveAccoutingTransactions`,
      billingDataIds,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const rejectAccountingTransaction = async (billingDataIds, reason) => {debugger;
  try {
    const response = await axios.post(
      `${BN_APP}/accounting-transaction/rejectAccoutingTransactions`,
      billingDataIds,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Content-Type": "application/json",
        },
        params: { reason },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const getAccountingApprovalTransactions = async (userData, filters = {}) => {
  try {
    const userDetails = {
      userId: userData.userID,
      userRole: userData.userRole,
      businessRole: userData.authorities || [],
    };

    // Construct the request body with ACCOUNTING_APPROVAL status and optional filters
    const requestBody = {
      userDetails,
      status: "ACCOUNTING_APPROVAL",
      materialType: Array.isArray(filters.materialType) && filters.materialType.length > 0 ? filters.materialType : null,
      approvalLevel: filters.approvalLevel || null,
      taxDepartureCountry: filters.taxDepartureCountry || null,
      pageType: "ACCOUNTING_APPROVAL",
    };

    const response = await axios.post(
      `${BN_APP}/transaction/getTransactions`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": process.env.REACT_APP_API_ROOT,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const getMaterialTypes = async () => {
  try {
    const response = await axios.get(
      `${BN_APP}/accounting-transaction/materialTypes`,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
